import { getSensitiveWord } from '@/api/common.js'
// 去除字符串中的所有空格
function removeAllSpaces(inputString) {
    return inputString.replace(/\s/g, '') // 使用正则表达式去除所有空格
  }
export default (text)=> {
    let data = removeAllSpaces(text)
    const formData = new FormData();
    formData.append('text', data);
    return getSensitiveWord(formData)
  }